module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-nl.7b46b839.png";